import React from 'react';

function ValidateInitialRouter(){
	function Init() {
		let token = localStorage.getItem('token');

		if(token === '' || token === null || token === undefined)
		    window.location.href = "/login";
		else
		    window.location.href = "/user";
	}

	React.useEffect(() => {
	    Init();
	},[]);

	return (
		<span id="ValidateInitialRoute"></span>
	);
}

export default ValidateInitialRouter;
